'use strict';

;( ( Chart ) => {

	const chartCanvas = document.getElementById( 'front-page-chart' );
	if ( null === chartCanvas ) return;

	const ctx      = chartCanvas.getContext( '2d' );
	const gradient = ctx.createLinearGradient( 0, 0, 0, 500 );

	// Set our style options.

	const colors = {
		border    : '#007396',
		background: gradient,
	};

	const gradientColorStops = [
		[ 0, 'rgba( 236, 247, 250, 1 )' ],
		[ 0.5, 'rgba( 236, 247, 250, 0.5 )'],
		[ 1, 'rgba( 236, 247, 250, 0 )' ],
	];

	if ( 'crime' === document.querySelector( 'html' ).dataset.theme ) {
		colors.border            = '#b15500';
		colors.background        = gradient;
		gradientColorStops[0][1] = 'rgba( 253, 246, 216, 1 )';
		gradientColorStops[1][1] = 'rgba( 253, 246, 216, 0.5 )';
		gradientColorStops[2][1] = 'rgba( 253, 246, 216, 0 )';
	}

	gradientColorStops.forEach( stop => gradient.addColorStop( ...stop ) );

	Chart.defaults.font.family = '"HCo Gotham SSm", "sans-serif"';

	const borderDashes = [
		[],
		[ 5, 5 ],
		[ 10, 5 ],
		[ 15, 10, 5, 10 ],
		[ 20, 10 ],
	];

	// Parse the data provided from ACF.

	const chartDataObj = JSON.parse( chartData );
	if ( ( null === chartDataObj ) || ( ! chartDataObj.data_sets ) ) return;

	const dataSets = [];

	chartDataObj.data_sets.forEach( ( dataSet, index ) => {
		const obj = {
			label          : dataSet.label,
			data           : dataSet.data.map( row => row.datum ),
			borderColor    : colors.border,
			backgroundColor: colors.background,
			pointStyle     : false,
			borderDash     : borderDashes[index],
			fill           : true,
		};

		dataSets.push( obj );
	});

	// Draw the chart.

	new Chart( chartCanvas, {
		type: 'line',
		data: {
			labels  : chartDataObj.data_sets[0].data.map( row => row.year ),
			datasets: dataSets,
		},
		options: {
			responsive: false,
			plugins   : {
				title: {
					display: true,
					text   : chartDataObj.chart_title,
					font   : {
						size: 14,
					},
					color: '#222222',
				},
				subtitle: {
					display: true,
					text   : chartDataObj.chart_subtitle,
					font   : {
						size : 14,
						style: 'italic',
					},
					color: '#222222',
				},
				legend: {
					position: 'bottom',
				},
			},
			scales: {
				x: {
					grid: {
						drawOnChartArea: false,
					},
					ticks: false,
				},
				y: {
					border: {
						display: false,
					},
					grid: {
						drawOnChartArea: false,
					},
					ticks: {
						padding: 0,
						font   : {
							size: 10,
						}
					},
				},
			},
		},
	});

})( Chart );
